// extracted by mini-css-extract-plugin
export default {"generatedMenu":"MealSelectorSelections-module__generatedMenu___31iVx","generatedMenuItems":"MealSelectorSelections-module__generatedMenuItems___3cr0g"};